// extracted by mini-css-extract-plugin
export var bHeading = "FeaturesList-module--bHeading--b3507";
export var bImage = "FeaturesList-module--bImage--2be5f";
export var desc2 = "FeaturesList-module--desc2--b1413";
export var hasImageC = "FeaturesList-module--hasImageC--6678d";
export var heading = "FeaturesList-module--heading--3c7d9";
export var image = "FeaturesList-module--image--af6da";
export var item = "FeaturesList-module--item--c1c3d";
export var subheading = "FeaturesList-module--subheading--3078e";
export var wrapper = "FeaturesList-module--wrapper--9f87f";